import React from 'react';
import guid from 'uuid';

const Carousel = (): JSX.Element => {
  const polygonId = guid();
  const maskId = guid();

  return (
    <svg viewBox="0 0 96 96">
      <defs>
        <polygon id={polygonId} points="0 0 48 0 48 48 0 48" />
      </defs>
      <g id="AssetsPanel/Component/InteractiveElements/CarouselElement" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(24, 24)">
          <mask id={maskId} fill="white">
            <use xlinkHref={`#${polygonId}`} />
          </mask>

          <path
            d="M8,8 L40,8 C42.21,8 44,9.79 44,12 L44,36 C44,38.21 42.21,40 40,40 L8,40 C5.79,40 4,38.21 4,36 L4,12 C4,9.79 5.79,8 8,8 Z"
            stroke="#E0E0E0"
            fillRule="nonzero"
            mask={`url(#${maskId})`}
          />

          <g mask={`url(#${maskId})`} fill="#5B5B5A" fillRule="nonzero">
            <rect x="8" y="14" width="8" height="20" rx="1" />
            <rect x="20" y="14" width="8" height="20" rx="1" />
            <rect x="32" y="14" width="8" height="20" rx="1" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Carousel;
